import { GoogleAnalyticsService } from 'app/google-analytics.service';
import {Component, ElementRef, ViewChild, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IdexService} from 'app/idex.service';
import {Mimetype} from 'app/shared/mimetype';
import {Path} from 'app/shared/path';

@Component({
   selector: 'app-dms-search',
   templateUrl: './search-box.component.html',
   styleUrls: ['./search-box.component.css']
})
export class DmsSearchBoxComponent implements OnInit {
   @ViewChild('q', {static: true}) query: ElementRef;
   private timer: any;
   private pos = 50;
   private size = 8;
   searchFocused: boolean;
   searchResult: any[];
   preventBlur: boolean;
   hasMore = false;
   items: any[] = [];
   filterSearch: boolean;
   lessItem: boolean;
   isClear= false;
   @Input() searchSelected = false;
   @Input() typeName: any;
   @Output() selectPath = new EventEmitter<boolean>();
   @Output() isSearch = new EventEmitter<boolean>();
   @Output() searchInput = new EventEmitter<string>();

   constructor(private router: Router, private route: ActivatedRoute, private service: IdexService ,private googleAnalyticsService:GoogleAnalyticsService) {
   }

   ngOnInit(): void {
      if (this.searchSelected) {
         this.filterSearch = true;
      }
      this.route.queryParams.subscribe(params => {
         let q;
         if (params['q']) {
            q = decodeURIComponent(params['q']);
         }
         this.query.nativeElement.value = q || '';
      });
   }

   onSearchChange(input: any) {
      this.items = null;
      this.searchResult = null;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const q = input.value.trim();
      if (q.length === 0) {
         return;
      }
      if(this.searchSelected){
         this.searchInput.emit(q);
         this.pos =  50;
         this.size = 50;
      }

      if(!this.searchSelected || (this.searchSelected && q.length >= 3)) {
         this.timer = setTimeout(() => {
            this.timer = null;

            this.service.search(encodeURIComponent(q), 0, this.size, false, false, this.filterSearch)
               .subscribe(
                  data => {

                     const eventParams = {
                        event_page: 'dms',
                        event_label: 'search-dms',
                        event_action: 'search',
                        event_search_text: q,
                      };

                     this.googleAnalyticsService.trackEvent("zdox-search",eventParams)
                     if (this.timer == null) {
                        this.hasMore = data.hasMore;
                        this.searchResult = data.items;
                        this.items = data.items;
                        if (this.items.length < 8 && this.hasMore && this.searchSelected) { // เช๋คกรณีตัวเลือกน่อยกว่า 8 แล้วมี hasmore โหลดเพิ่ม
                           this.lessItem = true;
                           this.loadMore('', input);
                        }
                     }
                  });
         }, 300);
      } else if(this.searchSelected && q.length < 3){
         this.items = [];
      }
   }

   onSearchFocus() {
      this.searchFocused = true;
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   clearCheck(input: any) {
      if(input.value.length === 0 && this.searchSelected){// check change back to tree
         this.isSearch.emit(false);
         this.isClear = false;
      }
   }

   search(input: any) {
      input.blur();
      const eventParams = {
         event_page: 'dms',
         event_label: 'search-dms',
         event_action: 'search',
         event_search_text: input.value,
       };

      this.googleAnalyticsService.trackEvent("zdox-search",eventParams)
      if (!this.searchSelected) {
         this.router.navigate(['/search'], {queryParams: {q: input.value}});
      }
      if (this.searchSelected && input.value.length>2) {
         this.isSearch.emit(true);
         this.isClear = true;
      }
   }

   clearSearch(input: any) {
      const q = input.value.trim();
      if (this.searchSelected && q.length !== 0 && this.isClear === true && this.searchFocused === false) {
         this.isSearch.emit(false);
         this.query.nativeElement.value = '';
         this.isClear = false;
      }
   }

   selectSearchItem(item: any) {
      let path = location.pathname;
      const idex = '/idex';
      if (path.startsWith(idex)) {
         path = path.substring(idex.length);
      }
      this.preventBlur = true;
      if (item.isFolder) {
         let url = Path.combine('/files', item.path, item.fileName);
         if (!item.path.startsWith('/')) {
            url = Path.combine('/work', item.linkPath, item.fileName);
         }
         if (!this.searchSelected) {
            this.router.navigate([url]);
         }
      } else {
         if (!this.searchSelected) {
            this.router.navigate(['/file', item.id]);
         } else if (((item.permissions.write && !item.isFolder) && ((!item.startFlow && item.statusDocument === '') || item.statusDocument === 'Completed')
            && this.getValidateExtension(item.mimeType)) && this.searchSelected) {
            this.query.nativeElement.value = item.name;
            this.selectPath.emit(item);
         }
      }
      this.preventBlur = false;
      this.searchFocused = false;
   }

   loadMore(e, item: any) {
      if ((e.target.scrollHeight <= e.target.scrollTop + e.target.offsetHeight || this.lessItem) && this.hasMore) {
         if (this.timer) {
            clearTimeout(this.timer);
         }
         const q = item.value.trim();
         if (q.length === 0) {
            return;
         }
         this.timer = setTimeout(() => {
            this.timer = null;
            this.service.search(encodeURIComponent(q), this.pos, this.size, false, false, true)
               .subscribe(
                  data => {
                     if (this.timer == null) {
                        this.hasMore = data.hasMore;
                        this.items.push.apply(this.items, data.items);
                        this.pos += this.size;
                        if (this.items.length < 8 && this.hasMore && this.searchSelected) { // เช๋คกรณีตัวเลือกน่อยกว่า 8 แล้วมี hasmore โหลดเพิ่ม
                           this.lessItem = true;
                           this.loadMore('', item);
                        } else {
                           this.lessItem = false;
                        }
                     }
                  });
         }, 300);
      }
   }

   getIcon(item: any): string {
      return Mimetype.getIcon(item);
   }

   getValidateExtension(item:any):boolean{
      return Mimetype.validateExtension(item,this.typeName);
   }
}
